import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { MatRadioButton } from '@angular/material/radio';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-radio-button-card',
    templateUrl: './radio-button-card.component.html',
    styleUrls: ['./radio-button-card.component.scss'],
    imports: [MatRadioButton, MatIcon]
})
export class RadioButtonCardComponent implements AfterViewInit {
    @ViewChild('radioButton')
    radio: MatRadioButton;

    @Input() label: string;
    @Input() value: string;
    @Input() description: string;
    @Input() icon: string;
    @Input() checked = false;

    ngAfterViewInit(): void {
        setTimeout(() => {
            if (this.checked) {
                this.radio.checked = true;
            }
        }, 0);

    }

    checkRadio(event: MouseEvent): void {
        // eslint-disable-next-line no-underscore-dangle
        this.radio._onInputInteraction(event);
    }
}
